module.exports = __webpack_public_path__ + "static/media/(000037).f184a169.jpg";